import { fetchApi } from '../api/digitalVault';
import { eSearchGet } from '../api/eSearch';
import getUserCollections from '../collectionManager/getUserCollections';
import { getFileByChecksums, getPlaylistCovers } from '../digitalVault';
import { parsePlaylists, parseResponse, parseUserResponse } from '../utils';
export const eSearch = async ({ query, count, lang = 'en_US', categories, dates, from = 0, allowedCategories = {}, }, logger) => {
    const queryParams = new URLSearchParams();
    queryParams.append('query', query);
    count && queryParams.append('count', count.toString());
    categories && queryParams.append('categories', categories);
    lang && queryParams.append('lang', lang.replace(/es-.*/, 'es-ES').replace('-', '_'));
    from && queryParams.append('from', from.toString());
    if (dates && categories === 'photo') {
        queryParams.append('dates', dates);
    }
    const response = await eSearchGet(`search?${queryParams.toString()}`, {}, logger);
    const filteredCategories = response.filter((category) => category.total > 0 && allowedCategories.hasOwnProperty(category?.category));
    if (categories && filteredCategories.length > 0 && filteredCategories[0].items.length > 0) {
        if (categories === 'collection_highlight' ||
            categories === 'collection_flashback' ||
            categories === 'collection_photo_album' ||
            categories === 'collection_music_playlist' ||
            categories === 'collection_other') {
            const collectionItems = filteredCategories.reduce((catItem, category) => {
                catItem.push(...category.items);
                return catItem;
            }, []);
            const collectionDetailsArray = await Promise.all(collectionItems.map(async (collectionItem) => {
                if (collectionItem.collectionId) {
                    let source = '';
                    if (categories.includes('collection_highlight') &&
                        categories.includes('collection_flashback')) {
                        source = 'highlights,flashbacks'; // Handle both cases if both are present
                    }
                    else if (categories.includes('collection_highlight')) {
                        source = 'highlights'; // If only highlights
                    }
                    else if (categories.includes('collection_flashback')) {
                        source = 'flashbacks'; // If only flashbacks
                    }
                    const cacheKeyPrefix = 'memories';
                    const collectionCacheProps = {
                        enableCache: false,
                        cacheKeyPrefix,
                        validateCache: true,
                    };
                    try {
                        const getUserCollectionsResponse = await getUserCollections({
                            count: 40,
                            start: 0,
                            source,
                        }, cacheKeyPrefix, collectionCacheProps);
                        // To get the first matching item
                        const matchingItem = getUserCollectionsResponse.data.find((responseItem) => responseItem.collectionData.id === collectionItem.collectionId);
                        return matchingItem || null;
                    }
                    catch (error) {
                        return null;
                    }
                }
                else {
                    return null;
                }
            }));
            // Filter out null values from the collectionDetailsArray
            const validCollectionDetails = collectionDetailsArray.filter((item) => item !== null);
            return parseResponse(from < response[0].total, validCollectionDetails, () => validCollectionDetails, () => {
                from += count;
                return eSearch({ query, count, lang, categories, dates, from, allowedCategories }, logger);
            });
        }
        if (categories === 'playlist' || categories === 'photo_album') {
            const playlistItems = filteredCategories.reduce((catItem, category) => {
                catItem.push(...category.items);
                return catItem;
            }, []);
            // Fetch playlist details and items for each playlistUid
            const playlistDetailsArray = await Promise.all(playlistItems.map(async (playlistItem) => {
                if (playlistItem.playlistUid) {
                    const rawResponse = await fetchApi({}, `playlist/${playlistItem.playlistUid}`);
                    const [playlist] = await parsePlaylists(rawResponse.playlistDefinition, false);
                    getPlaylistCovers([playlist], 'eSearch');
                    return playlist;
                }
            }));
            return parseResponse(from < response[0].total, playlistDetailsArray, () => playlistDetailsArray, () => {
                from += count;
                return eSearch({ query, count, lang, categories, dates, from, allowedCategories }, logger);
            });
        }
        const checksumAndRepoArray = filteredCategories[0].items.map((item) => {
            const repoNameArray = item?.repoPaths?.map((path) => {
                return {
                    $: [path.split(':/')[0]],
                };
            });
            return {
                '@checksum': item.checksum,
                repositoryName: repoNameArray,
            };
        });
        const { files } = await getFileByChecksums({
            checksumAndRepositoryNames: checksumAndRepoArray,
        });
        const nextFrom = from + count;
        const hasMoreItems = nextFrom < response[0].total;
        return parseUserResponse(hasMoreItems, files, async () => {
            return eSearch({
                query,
                count,
                lang,
                categories,
                dates,
                from: nextFrom,
                allowedCategories,
            }, logger);
        });
    }
    return filteredCategories;
};
